import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public searchBarVisible = signal(true);
  public userButtonVisible = signal(true);
}
